<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <discount-form :isUp="isUp"></discount-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import discountForm from './Temp/DiscountForm.vue'
export default {
  components: {
    'discount-form': discountForm
  },
  data () {
    return {
      isUp: true
    }
  },
  methods: {

  },
  created () {
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpDiscount.vue?b5ad5642